import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD0TYSatMiNbz4KBjzkxIsEpNHq9_4WAcY",
  authDomain: "whatsapp-clone-285fb.firebaseapp.com",
  projectId: "whatsapp-clone-285fb",
  storageBucket: "whatsapp-clone-285fb.appspot.com",
  messagingSenderId: "942243966230",
  appId: "1:942243966230:web:8a45ac1c59e2785a5cb437",
  measurementId: "G-Q1PR1VVBKX"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;